<div class="content">
    <span class="mat-title">Seu currículo</span>
    <input type="file" name="curriculo" accept=".pdf" #curriculoUpload hidden (change)="changeFile($event)" />
    <ng-container *ngIf="submiting">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>
    <div class="empty-content">
        <ng-container *ngIf="previewUpload">
            <p class="mat-body-1">Preparando para enviar {{ previewUpload.name }}</p>
        </ng-container>
        <ng-container *ngIf="!previewUpload">
            <ng-container *ngIf="curriculo">
                <mat-icon class="curriculo-icon">description</mat-icon>
                <p class="mat-body-1">Você enviou seu currículo em {{ curriculo.date_created | date:'d \'de\' MMMM \'de\' y' }}.</p>
            </ng-container>
            <ng-container *ngIf="!curriculo">
                <p class="mat-body-1">Nenhum currículo enviado ainda!</p>
            </ng-container>

        </ng-container>

        <ng-container *ngIf="!submiting">
            <button mat-raised-button color="primary" type="button" (click)="openUpload()">
                <mat-icon>description</mat-icon>
                Enviar Currículo PDF
            </button>
        </ng-container>
        <br />
        <!-- <ng-container *ngIf="downloadLink">
            <a mat-button color="primary" target="_blank" [download]="true" [href]="downloadLink">
                Gerar e baixar curriculo
            </a>
        </ng-container> -->

        <button mat-button color="primary" (click)="linkDownload()" [disabled]="submiting">
            Gerar e baixar currículo
        </button>

    </div>
</div>